
import { useState } from "react";

import { FilledButton, OutlinedButton } from "../../common/Button";


import useCurrentUser from "../../../hooks/useCurrentUser";
import { IFreelancer } from "../../../data_models/freelancer";
import Lightbox from "../../common/Lightbox";


interface UpgradeToPmLightboxProps {
    onClose: () => void;
}

export const UpgradeToPmLightbox: React.FC<UpgradeToPmLightboxProps> = ({ onClose }) => {

    const [loading, setLoading] = useState(false);

    const { updateCurrentUser } = useCurrentUser();


    const onSubmit = async () => {
        setLoading(true);
        try {
            await updateCurrentUser({ projectManagerIntent: true } as IFreelancer);
        } catch (error: any) {
        } finally {
            setLoading(false);
            onClose();
        }
    }

    return (
        <Lightbox
            content={
                <div className="flex flex-col items-start space-y-4" >
                    <h4>Do you want to apply as Project Manager?</h4>
                    <p>By submitting, you'll express your interest to help out as PM. Our team will reach out shortly for vetting.</p>
                    {/* <p className="font-bold">Responsibilities As PM</p>
                    <ul>
                        <li>Communicate with clients to fully understand project details</li>
                        <li>Act as the bridge between clients and freelancers</li>
                        <li>Define project scope clearly to avoid misunderstandings</li>
                        <li>Break projects into actionable tasks</li>
                        <li>Provide realistic time and cost estimates</li>
                        <li>Assign suitable freelancers to tasks or onboard new talent if needed</li>
                        <li>Form teams when additional speed or expertise is required</li>
                        <li>Oversee the project from start to finish, staying responsive to client and freelancers</li>
                        <li>Ensure high-quality deliverables that meet client expectations</li>
                    </ul> */}
                    <div className="flex flex-row justify-end w-full space-x-2">

                        <OutlinedButton onClick={onClose}>Cancel</OutlinedButton>
                        <FilledButton
                            isLoading={loading}
                            onClick={onSubmit}>Submit</FilledButton>
                    </div>
                </div>}
            onClose={onClose}
        />

    );
}

